import ContactUs1Container from "../../../components/pages/other/ContactUs1";

const ContactUs1 = () => {
  return <ContactUs1Container />;
};

export default ContactUs1;
